
import { useState } from "react"
import { Button } from "react-bootstrap"
import { Check, Loading } from "../assets/icons";
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore";


export default function ReadButton({id}) {


    const [borrando, setBorrando] = useState(false)
    // const [leida, setLeida] = useState(readed)
    const { URL: URL_MIO } = url()

    const notificacionesIndividuales = useEmpleadoStore(state => state.notificacionesIndividuales)
    const setNotificacionesIndividuales = useEmpleadoStore(state => state.setNotificacionesIndividuales)


    const markAsRead = () => {


        setBorrando(true)
        const body = {
            funcion: 'leer_notificacion',
            id
        }


        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify(body)
        })
        .then(respuesta => respuesta.json())
        .then(datos => {

            // eslint-disable-next-line
            if (datos.tipo == 1) {
                // setLeida(1)
                actualizarBoton()
            } else {
                // setLeida(0)
            }
        })
        .catch(err => {
            // alert('Hay problemas al marcar como leída.')
        })
        .finally(() => setBorrando(false))

    }


    const actualizarBoton = () => {
        var not = notificacionesIndividuales.map( n => {
            // eslint-disable-next-line
            if (n.id == id) {
                n.leida = 1
                return n
            }
            return n
        })
        setNotificacionesIndividuales(not)
    }

    if ( borrando ) return <Loading/>

    // eslint-disable-next-line
    const ele = notificacionesIndividuales.find( n => n.id == id )
    // eslint-disable-next-line
    if (ele.leida == 1) {
        return <div></div>
    } else {
        return <Button size="sm" onClick={ () => markAsRead(id) } variant="link"><Check/></Button>
    }

}

